/* Isolated Flex product-form integration; ordinary templates are not enabled. */
(() => {
  'use strict';
  const mount = async (root) => {
    if (root.dataset.cjNativeMounted) return;
    root.dataset.cjNativeMounted = 'true';
    const form = root.closest('form');
    const wrapper = root.closest('[data-product-form]');
    const fields = root.querySelector('[data-cj-native-fields]');
    const status = root.querySelector('[data-cj-native-status]');
    if (!form || !wrapper) return;
    const buttons = () => form.querySelectorAll('[data-add-to-cart-trigger]');
    const values = new Map();
    const validators = new Map();
    let product, ready = false, available = root.dataset.available === 'true';
    const lock = () => buttons().forEach(button => { button.disabled = !ready || !available; });
    const validate = (input, definition) => {
      const value = input.value;
      let message = '';
      if (definition.required === 1 && !value.trim()) message = 'Please enter your engraving.';
      if (value && definition.minlength != null && value.length < Number(definition.minlength)) message = `Please enter at least ${definition.minlength} characters.`;
      if (definition.maxlength != null && value.length > Number(definition.maxlength)) message = `Please use no more than ${definition.maxlength} characters.`;
      const pattern = definition.native_behavior?.pattern || definition.pattern;
      if (!message && value && pattern && !new RegExp(`^(?:${pattern})$`).test(value)) message = definition.pattern_message || 'Please use the characters supported for this engraving.';
      input.setCustomValidity(message);
    };
    const guard = (event) => {
      validators.forEach((definition, input) => validate(input, definition));
      if (!ready || !available || !form.checkValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (ready && available) form.reportValidity();
      }
    };
    form.addEventListener('submit', guard, true);
    form.addEventListener('click', event => {
      if (event.target.closest('[data-add-to-cart-trigger]')) guard(event);
    }, true);
    const fail = (message) => { ready = false; lock(); status.textContent = message; };
    const render = (id) => {
      fields.querySelectorAll('input[name]').forEach(input => { if (input.type !== 'radio' || input.checked) values.set(input.name, input.value); });
      ready = false;
      lock();
      fields.replaceChildren();
      validators.clear();
      const variant = product?.variants.find(item => item.id.split('/').pop() === String(id));
      if (!variant || variant.photo_upload || variant.native_component_review.length) {
        fail('This personalization preview is not ready yet.');
        return;
      }
      const names = new Set(variant.active_property_names);
      const definitions = variant.supplier_fields.filter(field => names.has(field.name));
      if (definitions.some(field => (field.type !== 'text' || field.field_type !== 'engraving') && field.native_behavior?.component !== 'birthstone_radio')) {
        fail('This personalization preview is not ready yet.');
        return;
      }
      definitions.forEach((definition, index) => {
          if (definition.native_behavior?.component === 'birthstone_radio') {
            if (definition.type !== 'radio' || definition.field_type !== 'birthstone' || !Array.isArray(definition.options) || definition.options.length !== 12) throw new Error('Unsupported birthstone contract');
            const group = document.createElement('fieldset');
            group.className = 'cj-birthstone';
            const legend = document.createElement('legend');
            legend.textContent = definition.label || definition.name;
            group.append(legend);
            definition.options.forEach((month, optionIndex) => {
              const label = document.createElement('label');
              const input = document.createElement('input');
              input.type = 'radio';
              input.name = `properties[${definition.name}]`;
              input.id = `cj-stone-${root.dataset.productId}-${index}-${optionIndex}`;
              input.value = month;
              input.required = definition.required === 1;
              input.checked = values.get(input.name) === month;
              label.htmlFor = input.id;
              const text = document.createElement('span');
              text.textContent = month;
              label.append(input, text);
              group.append(label);
            });
            fields.append(group);
            return;
          }

        const pattern = definition.native_behavior?.pattern || definition.pattern;
        if (pattern) new RegExp(`^(?:${pattern})$`);
        const input = document.createElement('input');
        const label = document.createElement('label');
        input.type = 'text';
        input.id = `cj-integrated-${root.dataset.productId}-${index}`;
        input.name = `properties[${definition.name}]`;
        input.value = values.get(input.name) || '';
        input.placeholder = definition.placeholder || '';
        input.autocomplete = 'off';
        input.required = definition.required === 1;
        if (definition.maxlength != null) input.maxLength = Number(definition.maxlength);
        if (definition.minlength != null) input.minLength = Number(definition.minlength);
        if (definition.native_behavior?.font_family) input.style.fontFamily = `${definition.native_behavior.font_family}, sans-serif`;
        label.htmlFor = input.id;
        label.textContent = definition.label || definition.name;
        validators.set(input, definition);
        input.addEventListener('input', () => {
          if (definition.native_behavior?.uppercase) input.value = input.value.toUpperCase();
          validate(input, definition);
        });
        validate(input, definition);
        fields.append(label, input);
      });
      status.textContent = definitions.length ? 'Check your engraving carefully before adding it to your bag.' : 'No engraving for this option.';
      ready = true;
      lock();
    };
    wrapper.addEventListener('kit:variant-picker:change', () => { ready = false; lock(); });
    wrapper.addEventListener('variant-change', event => {
      available = event.detail?.variant?.available === true;
      try { render(event.detail?.variant?.id); }
      catch (_) { fail('This personalization preview is not ready yet.'); }
      queueMicrotask(lock);
    });
    lock();
    try {
      const response = await fetch(root.dataset.catalogUrl, {credentials: 'omit'});
      if (!response.ok) throw new Error('Catalog unavailable');
      const catalog = await response.json();
      product = catalog.products.find(item => item.id.split('/').pop() === root.dataset.productId);
      if (!product) throw new Error('Product not in verified catalog');
      render(form.querySelector('[name="id"]')?.value || root.dataset.initialVariant);
    } catch (_) { fail('Personalization options could not load. Please reload the page.'); }
  };
  document.querySelectorAll('[data-cj-native-integrated]').forEach(mount);
})();
